import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBreadcrumbs, IAction } from './breadcrumbs.interface';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  onChange: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public data: IBreadcrumbs = { title: '', navList: [], actions: [], orderAction: 'before' };
  dynamicTemplate!: TemplateRef<any> | null;
  
  private updateCounter = 0;   

  constructor() {}

  public set(val: IBreadcrumbs): void {
    Object.assign(this.data, val);
    this.updateCounter=Math.random();
    this.onChange.next(this.updateCounter);      
  }

  public get(): IBreadcrumbs {
    return this.data;
  }

  public setTitle(val: string): void {
    Object.assign(this.data, { title: val });
    this.updateCounter= Math.random();
    this.onChange.next(this.updateCounter);  
  }

  public setAction(actions: IAction[]): void {
    Object.assign(this.data, { actions });
    this.updateCounter= Math.random();
    this.onChange.next(this.updateCounter);  
  }

  public addItem(val: { url: string; label: string }): void {
    this.data.navList.push(val);
    this.updateCounter= Math.random();
    this.onChange.next(this.updateCounter);  
  }

  public removeItem(index: number | null): void {
    if (index !== null) {
      this.data.navList.splice(index, 1);
    } else {
      this.data.navList.pop();
    }
    this.updateCounter= Math.random();
    this.onChange.next(this.updateCounter);  
  }

  passingDynamicTemplate(template: TemplateRef<any>) {
    this.dynamicTemplate = template;
    this.updateCounter= Math.random();
    this.onChange.next(this.updateCounter);     
  }

  resetTemplate() {
    this.dynamicTemplate = null;
    this.updateCounter= Math.random();
    this.onChange.next(this.updateCounter);     
  }

  getTemplate() {
    return this.dynamicTemplate;
  }
}
